// Map country names to their respective CSV files
const countryDataMap = {
    'Aland Islands': require('../CSV/Aland Islands.csv'),
    'Anguilla': require('../CSV/Anguilla.csv'),
    'Aruba': require('../CSV/Aruba.csv'),
    'Baker Island': require('../CSV/Baker Island.csv'),
    'Bonaire, Saint Eustachius and Saba': require('../CSV/Bonaire, Saint Eustachius and Saba.csv'),
    'Bouvet Island': require('../CSV/Bouvet Island.csv'),
    'British Indian Ocean Territory': require('../CSV/British Indian Ocean Territory.csv'),
    'British Virgin Islands': require('../CSV/British Virgin Islands.csv'),
    'Cayman Islands': require('../CSV/Cayman Islands.csv'),
    'Central African Republic': require('../CSV/Central African Republic.csv'),
    'Christmas Island': require('../CSV/Christmas Island.csv'),
    'Cocos Islands': require('../CSV/Cocos Islands.csv'),
    'Curacao': require('../CSV/Curacao.csv'),
    'Falkland Islands': require('../CSV/Falkland Islands.csv'),
    'Faroe Islands': require('../CSV/Faroe Islands.csv'),
    'French Guiana': require('../CSV/French Guiana.csv'),
    'French Polynesia': require('../CSV/French Polynesia.csv'),
    'French Southern and Antarctic Lands': require('../CSV/French Southern and Antarctic Lands.csv'),
    'Gibraltar': require('../CSV/Gibraltar.csv'),
    'Glorioso Islands': require('../CSV/Glorioso Islands.csv'),
    'Guadeloupe': require('../CSV/Guadeloupe.csv'),
    'Guernsey': require('../CSV/Guernsey.csv'),
    'Heard Island and McDonald Islands': require('../CSV/Heard Island and McDonald Islands.csv'),
    'Hong Kong': require('../CSV/Hong Kong.csv'),
    'Howland Island': require('../CSV/Howland Island.csv'),
    'Isle of Man': require('../CSV/Isle of Man.csv'),
    'Jarvis Island': require('../CSV/Jarvis Island.csv'),
    'Jersey': require('../CSV/Jersey.csv'),
    'Johnston Atoll': require('../CSV/Johnston Atoll.csv'),
    'Juan De Nova Island': require('../CSV/Juan De Nova Island.csv'),
    'Kosovo': require('../CSV/Kosovo.csv'),
    'Macau': require('../CSV/Macau.csv'),
    'Martinique': require('../CSV/Martinique.csv'),
    'Mayotte': require('../CSV/Mayotte.csv'),
    'Midway Islands': require('../CSV/Midway Islands.csv'),
    'Montserrat': require('../CSV/Montserrat.csv'),
    'New Caledonia': require('../CSV/New Caledonia.csv'),
    'Norfolk Island': require('../CSV/Norfolk Island.csv'),
    'Pitcairn Islands': require('../CSV/Pitcairn Islands.csv'),
    'Republic of Congo': require('../CSV/Republic of Congo.csv'),
    'Reunion': require('../CSV/Reunion.csv'),
    'Saint Barthelemy': require('../CSV/Saint Barthelemy.csv'),
    'Saint Helena': require('../CSV/Saint Helena.csv'),
    'Saint Martin': require('../CSV/Saint Martin.csv'),
    'Saint Pierre and Miquelon': require('../CSV/Saint Pierre and Miquelon.csv'),
    'South Georgia and South Sandwich Islands': require('../CSV/South Georgia and South Sandwich Islands.csv'),
    'Swaziland': require('../CSV/Swaziland.csv'),
    'Turks and Caicos Islands': require('../CSV/Turks and Caicos Islands.csv'),
    'US Virgin Islands': require('../CSV/US Virgin Islands.csv'),
    'Vatican City': require('../CSV/Vatican City.csv'),
    'Wake Island': require('../CSV/Wake Island.csv'),
    'Wallis and Futuna': require('../CSV/Wallis and Futuna.csv'),





    'Afghanistan': require('../CSV/Afghanistan.csv'),
    'Albania': require('../CSV/Albania.csv'),
    'Algeria': require('../CSV/Algeria.csv'),
    'American Samoa': require('../CSV/American Samoa.csv'),
    'Andorra': require('../CSV/Andorra.csv'),
    'Angola': require('../CSV/Angola.csv'),
    'Antigua and Barbuda': require('../CSV/Antigua and Barbuda.csv'),
    'Argentina': require('../CSV/Argentina.csv'),
    'Armenia': require('../CSV/Armenia.csv'),
    'Australia': require('../CSV/Australia.csv'),
    'Austria': require('../CSV/Austria.csv'),
    'Azerbaijan': require('../CSV/Azerbaijan.csv'),
    'Bahamas': require('../CSV/Bahamas.csv'),
    'Bahrain': require('../CSV/Bahrain.csv'),
    'Bangladesh': require('../CSV/Bangladesh.csv'),
    'Barbados': require('../CSV/Barbados.csv'),
    'Belarus': require('../CSV/Belarus.csv'),
    'Belgium': require('../CSV/Belgium.csv'),
    'Belize': require('../CSV/Belize.csv'),
    'Benin': require('../CSV/Benin.csv'),
    'Bermuda': require('../CSV/Bermuda.csv'),
    'Bhutan': require('../CSV/Bhutan.csv'),
    'Bolivia': require('../CSV/Bolivia.csv'),
    'Bosnia and Herzegovina': require('../CSV/Bosnia and Herzegovina.csv'),
    'Botswana': require('../CSV/Botswana.csv'),
    'Brazil': require('../CSV/Brazil.csv'),
    'Brunei Darussalam': require('../CSV/Brunei Darussalam.csv'),
    'Bulgaria': require('../CSV/Bulgaria.csv'),
    'Burkina Faso': require('../CSV/Burkina Faso.csv'),
    'Burundi': require('../CSV/Burundi.csv'),
    'Chad': require('../CSV/Chad.csv'),
    'Chile': require('../CSV/Chile.csv'),
    'Colombia': require('../CSV/Colombia.csv'),
    'Comoros': require('../CSV/Comoros.csv'),
    'Cook Islands': require('../CSV/Cook Islands.csv'),
    'Costa Rica': require('../CSV/Costa Rica.csv'),
    "Côte d'Ivoire": require("../CSV/Côte d'Ivoire.csv"),
    'Cuba': require('../CSV/Cuba.csv'),
    'Cyprus': require('../CSV/Cyprus.csv'),
    'Denmark': require('../CSV/Denmark.csv'),
    'Djibouti': require('../CSV/Djibouti.csv'),
    'Dominica': require('../CSV/Dominica.csv'),
    'Dominican Republic': require('../CSV/Dominican Republic.csv'),
    'Equatorial Guinea': require('../CSV/Equatorial Guinea.csv'),
    'Ecuador': require('../CSV/Ecuador.csv'),
    'Egypt': require('../CSV/Egypt.csv'),
    'El Salvador': require('../CSV/El Salvador.csv'),
    'Eritrea': require('../CSV/Eritrea.csv'),
    'Estonia': require('../CSV/Estonia.csv'),
    'Ethiopia': require('../CSV/Ethiopia.csv'),
    'Federated States of Micronesia': require('../CSV/Federated States of Micronesia.csv'),
    'Fiji': require('../CSV/Fiji.csv'),
    'Philippines': require('../CSV/Philippines.csv'),
    'Finland': require('../CSV/Finland.csv'),
    'France': require('../CSV/France.csv'),
    'Gabon': require('../CSV/Gabon.csv'),
    'Gambia': require('../CSV/Gambia.csv'),
    'Georgia': require('../CSV/Georgia.csv'),
    'Germany': require('../CSV/Germany.csv'),
    'Ghana': require('../CSV/Ghana.csv'),
    'Greece': require('../CSV/Greece.csv'),
    'Greenland': require('../CSV/Greenland.csv'),
    'Grenada': require('../CSV/Grenada.csv'),
    'Guam': require('../CSV/Guam.csv'),
    'Guatemala': require('../CSV/Guatemala.csv'),
    'Guinea': require('../CSV/Guinea.csv'),
    'Guinea-Bissau': require('../CSV/Guinea-Bissau.csv'),
    'Guyana': require('../CSV/Guyana.csv'),
    'Haiti': require('../CSV/Haiti.csv'),
    'Honduras': require('../CSV/Honduras.csv'),
    'Hungary': require('../CSV/Hungary.csv'),
    'India': require('../CSV/India.csv'),
    'Indonesia': require('../CSV/Indonesia.csv'),
    'Iraq': require('../CSV/Iraq.csv'),
    'Iran': require('../CSV/Iran.csv'),
    'Ireland': require('../CSV/Ireland.csv'),
    'Iceland': require('../CSV/Iceland.csv'),
    'Israel': require('../CSV/Israel.csv'),
    'Italy': require('../CSV/Italy.csv'),
    'Jamaica': require('../CSV/Jamaica.csv'),
    'Japan': require('../CSV/Japan.csv'),
    'Jordan': require('../CSV/Jordan.csv'),
    'Cambodia': require('../CSV/Cambodia.csv'),
    'Cameroon': require('../CSV/Cameroon.csv'),
    'Canada': require('../CSV/Canada.csv'),
    'Cape Verde': require('../CSV/Cape Verde.csv'),
    'Qatar': require('../CSV/Qatar.csv'),
    'China': require('../CSV/China.csv'),
    'Kyrgyzstan': require('../CSV/Kyrgyzstan.csv'),
    'Kazakhstan': require('../CSV/Kazakhstan.csv'),
    'Kenya': require('../CSV/Kenya.csv'),
    'Kiribati': require('../CSV/Kiribati.csv'),
    'Democratic Republic of Congo': require('../CSV/Democratic Republic of Congo.csv'),
    'Croatia': require('../CSV/Croatia.csv'),
    'Kuwait': require('../CSV/Kuwait.csv'),
    'Laos': require('../CSV/Laos.csv'),
    'Latvia': require('../CSV/Latvia.csv'),
    'Lebanon': require('../CSV/Lebanon.csv'),
    'Lesotho': require('../CSV/Lesotho.csv'),
    'Liberia': require('../CSV/Liberia.csv'),
    'Libya': require('../CSV/Libya.csv'),
    'Liechtenstein': require('../CSV/Liechtenstein.csv'),
    'Lithuania': require('../CSV/Lithuania.csv'),
    'Luxembourg': require('../CSV/Luxembourg.csv'),
    'Madagascar': require('../CSV/Madagascar.csv'),
    'Malawi': require('../CSV/Malawi.csv'),
    'Malaysia': require('../CSV/Malaysia.csv'),
    'Maldives': require('../CSV/Maldives.csv'),
    'Mali': require('../CSV/Mali.csv'),
    'Malta': require('../CSV/Malta.csv'),
    'Marshall Islands': require('../CSV/Marshall Islands.csv'),
    'Mauritania': require('../CSV/Mauritania.csv'),
    'Morocco': require('../CSV/Morocco.csv'),
    'Mauritius': require('../CSV/Mauritius.csv'),
    'Mexico': require('../CSV/Mexico.csv'),
    'Moldova': require('../CSV/Moldova.csv'),
    'Monaco': require('../CSV/Monaco.csv'),
    'Mongolia': require('../CSV/Mongolia.csv'),
    'Montenegro': require('../CSV/Montenegro.csv'),
    'Mozambique': require('../CSV/Mozambique.csv'),
    'Myanmar': require('../CSV/Myanmar.csv'),
    'Namibia': require('../CSV/Namibia.csv'),
    'Nauru': require('../CSV/Nauru.csv'),
    'Nepal': require('../CSV/Nepal.csv'),
    'Netherlands': require('../CSV/Netherlands.csv'),
    'Nicaragua': require('../CSV/Nicaragua.csv'),
    'Niger': require('../CSV/Niger.csv'),
    'Nigeria': require('../CSV/Nigeria.csv'),
    'Niue': require('../CSV/Niue.csv'),
    'North Korea': require('../CSV/North Korea.csv'),
    'Northern Mariana Islands': require('../CSV/Northern Mariana Islands.csv'),
    'Macedonia': require('../CSV/Macedonia.csv'),
    'Norway': require('../CSV/Norway.csv'),
    'New Zealand': require('../CSV/New Zealand.csv'),
    'Oman': require('../CSV/Oman.csv'),
    'Pakistan': require('../CSV/Pakistan.csv'),
    'Palau': require('../CSV/Palau.csv'),
    'Panama': require('../CSV/Panama.csv'),
    'Palestinian Territories': require('../CSV/Palestinian Territories.csv'),
    'Papua New Guinea': require('../CSV/Papua New Guinea.csv'),
    'Paraguay': require('../CSV/Paraguay.csv'),
    'Peru': require('../CSV/Peru.csv'),
    'Poland': require('../CSV/Poland.csv'),
    'Portugal': require('../CSV/Portugal.csv'),
    'Puerto Rico': require('../CSV/Puerto Rico.csv'),
    'Romania': require('../CSV/Romania.csv'),
    'Russia': require('../CSV/Russia.csv'),
    'Rwanda': require('../CSV/Rwanda.csv'),
    'Saint Kitts and Nevis': require('../CSV/Saint Kitts and Nevis.csv'),
    'Saint Lucia': require('../CSV/Saint Lucia.csv'),
    'Saint Vincent and the Grenadines': require('../CSV/Saint Vincent and the Grenadines.csv'),
    'Samoa': require('../CSV/Samoa.csv'),
    'San Marino': require('../CSV/San Marino.csv'),
    'Sao Tome and Principe': require('../CSV/Sao Tome and Principe.csv'),
    'Saudi Arabia': require('../CSV/Saudi Arabia.csv'),
    'Senegal': require('../CSV/Senegal.csv'),
    'Serbia': require('../CSV/Serbia.csv'),
    'Seychelles': require('../CSV/Seychelles.csv'),
    'South Africa': require('../CSV/South Africa.csv'),
    'South Korea': require('../CSV/South Korea.csv'),
    'Sweden': require('../CSV/Sweden.csv'),
    'Svalbard and Jan Mayen': require('../CSV/Svalbard and Jan Mayen.csv'),
    'Switzerland': require('../CSV/Switzerland.csv'),
    'Sierra Leone': require('../CSV/Sierra Leone.csv'),
    'Singapore': require('../CSV/Singapore.csv'),
    'Slovakia': require('../CSV/Slovakia.csv'),
    'Slovenia': require('../CSV/Slovenia.csv'),
    'Solomon Islands': require('../CSV/Solomon Islands.csv'),
    'Somalia': require('../CSV/Somalia.csv'),
    'Sri Lanka': require('../CSV/Sri Lanka.csv'),
    'South Sudan': require('../CSV/South Sudan.csv'),
    'Sudan': require('../CSV/Sudan.csv'),
    'Spain': require('../CSV/Spain.csv'),
    'Suriname': require('../CSV/Suriname.csv'),
    'Syria': require('../CSV/Syria.csv'),
    'Taiwan': require('../CSV/Taiwan.csv'),
    'Tajikistan': require('../CSV/Tajikistan.csv'),
    'Tanzania': require('../CSV/Tanzania.csv'),
    'Timor-Leste': require('../CSV/Timor-Leste.csv'),
    'Thailand': require('../CSV/Thailand.csv'),
    'Czech Republic': require('../CSV/Czech Republic.csv'),
    'Togo': require('../CSV/Togo.csv'),
    'Tokelau': require('../CSV/Tokelau.csv'),
    'Tonga': require('../CSV/Tonga.csv'),
    'Trinidad and Tobago': require('../CSV/Trinidad and Tobago.csv'),
    'Tunisia': require('../CSV/Tunisia.csv'),
    'Turkey': require('../CSV/Turkey.csv'),
    'Turkmenistan': require('../CSV/Turkmenistan.csv'),
    'Tuvalu': require('../CSV/Tuvalu.csv'),
    'Uganda': require('../CSV/Uganda.csv'),
    'Ukraine': require('../CSV/Ukraine.csv'),
    'United Arab Emirates': require('../CSV/United Arab Emirates.csv'),
    'Uruguay': require('../CSV/Uruguay.csv'),
    'United Kingdom': require('../CSV/United Kingdom.csv'),
    'United States of America': require('../CSV/United States of America.csv'),
    'Uzbekistan': require('../CSV/Uzbekistan.csv'),
    'Vanuatu': require('../CSV/Vanuatu.csv'),
    'Venezuela': require('../CSV/Venezuela.csv'),
    'Vietnam': require('../CSV/Vietnam.csv'),
    'Western Sahara': require('../CSV/Western Sahara.csv'),
    'Yemen': require('../CSV/Yemen.csv'),
    'Zambia': require('../CSV/Zambia.csv'),
    'Zimbabwe': require('../CSV/Zimbabwe.csv'),
    // Add more countries as needed
};
export default countryDataMap;